module.exports = __webpack_public_path__ + "img/suspended2.65267f5e.svg";